import { faBan } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { type PropsWithChildren, useEffect } from "react";

import { T } from "@repo/transifex";

import { AnimatedButton } from "../animated-button";

const ANIMATION_DURATION = 3000;

type ScreenErrorProps = PropsWithChildren<{
  onClose: () => void;
  withAnimation?: boolean;
  animationDuration?: number;
}>;

export const ScreenError = ({
  onClose,
  children,
  withAnimation = true,
  animationDuration = ANIMATION_DURATION
}: ScreenErrorProps) => {
  useEffect(() => {
    const audioPlayer = new Audio("/audio/ticket-validation-fail.wav");
    audioPlayer.play();
  }, []);

  return (
    <div className="flex h-full flex-col items-center justify-center bg-danger-main px-8">
      <FontAwesomeIcon icon={faBan} fontSize={250} className="text-white" />

      <div className="flex flex-col items-center justify-center gap-4 pb-12 pt-6">
        {children}
      </div>

      <AnimatedButton
        className="!rounded-xl !bg-white/10 shadow-md"
        overlayClassName="bg-white/30"
        animationDuration={animationDuration}
        disableAnimation={!withAnimation}
        variant="danger"
        size="large"
        onClick={onClose}
      >
        <T _str="Close" />
      </AnimatedButton>
    </div>
  );
};

export const ScreenErrorTitle = ({ children }: PropsWithChildren) => {
  return (
    <p className="text-center text-7xl font-semibold text-white">{children}</p>
  );
};

export const ScreenErrorText = ({ children }: PropsWithChildren) => {
  return (
    <p className="text-center text-2xl text-secondary-light">{children}</p>
  );
};
